
export const isArrayOfType = <T>(arr: T[] | any[], type: string): arr is T[] => arr.length === 0 || typeof arr[0] === type;
export const isArrayOfString = (arr: string[] | any[]): arr is string[] => isArrayOfType<string>(arr, 'string');
export const isArrayOfNumber = (arr: number[] | any[]): arr is number[] => isArrayOfType<number>(arr, 'number');